import { Stack, Text } from "@fluentui/react";
import { DocumentOnePageSparkleRegular } from "@fluentui/react-icons";
import { Card, Chip } from "@mui/material";
import { STYLES } from "../../../../helper/CRMEngagementAISummaryPanel";
import { PromptLibraryItem } from "../../../../interfaces/slices.interfaces";
import { PromptCardButtonWithPanel } from "../Common";

export const PromptCard = (prompt: PromptLibraryItem) => (
  <Card
    style={{
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "space-between",
      margin: 1,
      marginBottom: 8,
      minHeight: 230,
      padding: 16
    }}
  >
    <Stack>
      <Stack horizontal verticalAlign="start" tokens={{ childrenGap: 8 }}>
        <div style={{ height: 20, paddingTop: 5, width: 25 }}>
          <DocumentOnePageSparkleRegular style={STYLES.textContainerLabelIcon} />
        </div>
        <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
          {prompt.title}
        </Text>
      </Stack>
      <Text variant="mediumPlus" styles={{ root: { margin: "16px 0" } }}>
        {prompt.description}
      </Text>
    </Stack>
    <div>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <PromptCardButtonWithPanel {...prompt} />
        <Stack
          horizontal
          verticalAlign="center"
          styles={{
            root: {
              padding: 5,
              display: "inline-flex"
            }
          }}
          tokens={{ childrenGap: 5 }}
        >
          {prompt.tags
            .split(";")
            .map((tag: any) => tag && <Chip key={crypto.randomUUID()} label={tag} size="small" variant="outlined" />)}
        </Stack>
      </Stack>
    </div>
  </Card>
);
